export const YM_WINDOW_KEY: keyof Window = `ym` as keyof Window
